// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// #124 react-joyride Time Machine tutorial — pure payload builder.
//
// Constructs the `{ filter, update }` object the setUserById mutation
// expects, with the positional `$` operator pointed at the array
// element matching the target tutorialKey.
//
// Schema:
//   tutorials: [
//     { key, completed, completedAt, version }
//     // future tutorials append as new elements
//   ]
//
// Filter shape (`{ username, "tutorials.key": tutorialKey }`) is what
// "positions" the `$` in the update. MongoDB updates the FIRST array
// element matching that key — which, since keys are unique per user,
// is the single correct element.
//
// Pure function so tests can assert on the returned shape without
// mocking TanStack mutations or the Lambda endpoint.

const TUTORIAL_STATE_VERSION_DEFAULT = "1.0";

function buildSetTutorialStatePayload({
  username,
  tutorialKey,
  completed,
  version,
  changedBy,
  now = new Date(),
}) {
  if (typeof username !== "string" || username === "") {
    throw new Error("buildSetTutorialStatePayload: username is required");
  }
  if (typeof tutorialKey !== "string" || tutorialKey === "") {
    throw new Error("buildSetTutorialStatePayload: tutorialKey is required");
  }
  if (typeof completed !== "boolean") {
    throw new Error("buildSetTutorialStatePayload: completed must be a boolean");
  }

  const effectiveVersion = version || TUTORIAL_STATE_VERSION_DEFAULT;
  const completedAt = completed ? now.toISOString() : null;

  return {
    filter: { username, "tutorials.key": tutorialKey },
    update: {
      $set: {
        "tutorials.$.completed": completed,
        "tutorials.$.completedAt": completedAt,
        "tutorials.$.version": effectiveVersion,
        _lastChangedAt: now.toISOString(),
        _lastChangedBy: changedBy || username,
        _changeSource: "Scheduler-UI",
      },
    },
  };
}

export { buildSetTutorialStatePayload, TUTORIAL_STATE_VERSION_DEFAULT };
